import component from './containers/container';

export default component;
